import { UserRole, userRoleFromJson } from './user-role';

export interface Profile {
  id: string;
  username: string | null;
  displayName: string | null;
  avatarUrl: string | null;
  bannerUrl: string | null;
  bio: string | null;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
}

export function profileNeedsOnboarding(profile: Profile | null): boolean {
  return profile == null || profile.username == null || profile.username === '';
}

export function profileFromJson(json: Record<string, unknown>): Profile {
  return {
    id: json['id'] as string,
    username: (json['username'] as string | null) ?? null,
    displayName: (json['display_name'] as string | null) ?? null,
    avatarUrl: (json['avatar_url'] as string | null) ?? null,
    bannerUrl: (json['banner_url'] as string | null) ?? null,
    bio: (json['bio'] as string | null) ?? null,
    role: userRoleFromJson(json['role'] as string | null | undefined),
    createdAt: json['created_at'] as string,
    updatedAt: json['updated_at'] as string,
  };
}
